export default __webpack_public_path__ + "static/media/background.b3197b40.jpg";